import React, { useState } from 'react'
import styled from '@emotion/styled'

import { HeaderWithButtons, PageWithTitle, FlexColumn, LightBGContainer } from '../styles/Containers'
import BodyText, { PageTitle, BoldFormTitle } from '../styles/Text'
import axios from '../../dataClient/dataClient'
import Button from '../common/Button'
import { ErrorMessage } from '../common/UserMessage'
import { handleDownloadResponse } from '../../util/downloadFile'
import ReportSection from '../reports/ReportSection'

const REPORT_SECTIONS = [
  {
    title: 'Requests Received',
    items: ['Number of requests received by applicant type']
  },
  {
    title: 'Requests Closed',
    groups: [
      {
        heading: 'Disposition',
        items: ['Number of requests closed by applicant type', 'Number of requests with a response provided to the applicant']
      },
      {
        heading: 'Compliance with Time Limits',
        items: [
          'Number and percent of requests concluded within time limit and after time limit passed',
          'Average number of days after time limit passed to conclude requests'
        ]
      },
      {
        heading: 'Timeliness of Responses',
        items: [
          'Average number of days to respond to requests',
          'Number and percent of requests responded to by business days (<30, 31-60, 61-120, and 120+)'
        ]
      },
      {
        heading: 'Application and Processing Fees',
        items: [
          'Number of requests and total dollar amount of application fees charged and collected',
          'Number of requests and total dollar amount of processing fees charged, collected, and waived'
        ]
      }
    ]
  },
  {
    title: 'Requests Currently Overdue',
    items: [
      'Number of requests past time limit where public body has yet to respond',
      'Number and percent of requests still open past time limit by business days (<30, 31-60, 61-120, and 120+)'
    ]
  }
]

const HeaderActions = styled(FlexColumn)`
  align-items: flex-end;
`

function FOIReportingPage() {
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [downloadError, setDownloadError] = useState(false)

  function generateReport() {
    setDownloadLoading(true)
    setDownloadError(false)

    axios
      .get('/oipc/download', { responseType: 'blob' })
      .then(response => {
        const reportDate = new Date().toISOString().slice(0, 10)
        handleDownloadResponse(response, `foi-metrics-${reportDate}.pdf`, 'download')
      })
      .catch(e => {
        setDownloadError(true)
        console.error('an error occurred while downloading the OIPC metrics report', e)
      })
      .finally(() => {
        setDownloadLoading(false)
      })
  }

  return (
    <PageWithTitle gap="15px">
      <HeaderWithButtons>
        <PageTitle>FOI Reporting</PageTitle>
        <HeaderActions gap="10px">
          <Button onClick={generateReport} loading={downloadLoading}>
            Generate Report
          </Button>
          {downloadError && <ErrorMessage />}
        </HeaderActions>
      </HeaderWithButtons>
      <LightBGContainer padding="30px">
        <FlexColumn gap="20px">
          <FlexColumn gap="8px">
            <BoldFormTitle>Report Content</BoldFormTitle>
            <BodyText>The generated PDF report will contain the following metrics:</BodyText>
          </FlexColumn>
          {REPORT_SECTIONS.map(section => (
            <ReportSection key={section.title} {...section} />
          ))}
        </FlexColumn>
      </LightBGContainer>
    </PageWithTitle>
  )
}

export default FOIReportingPage
